import styled from "styled-components";
import { fadeAndSlideIn } from "../HoverableImage/styles";

export const StyledPopover = styled.div`
  --popover-menu-surface: #071526;
  --popover-label-surface: #091c30;
  --popover-text: #f7fbff;
  --popover-border: rgba(89, 244, 119, 0.26);

  z-index: 1200;
  position: fixed;
  max-width: min(208px, calc(100vw - 80px));
  color: var(--popover-text);
  animation: 0.16s ease-out 0s 1 normal both running ${fadeAndSlideIn};
  pointer-events: ${({ $hasSubOptions }) => ($hasSubOptions ? "auto" : "none")};

  .container-popover {
    height: 100%;
    border: 1px solid var(--popover-border);
    border-radius: 10px;
    width: 100%;
    background: var(--popover-menu-surface);
    box-shadow:
      0 14px 32px rgba(0, 0, 0, 0.5),
      0 0 0 1px rgba(89, 244, 119, 0.04);
    overflow: hidden auto;
  }

  .popover-menu-content {
    padding: 0 6px 8px;
  }

  .crypto-futures-popover-content {
    padding: 0 8px;
  }

  .simple-popover {
    position: relative;
    display: flex;
    min-height: 32px;
    align-items: center;
    border: 1px solid var(--popover-border);
    border-radius: 8px;
    padding: 7px 11px;
    line-height: 1.2;
    white-space: nowrap;
    color: var(--popover-text);
    background: var(--popover-label-surface);
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.01em;
    box-shadow:
      0 10px 24px rgba(0, 0, 0, 0.48),
      0 0 0 1px rgba(89, 244, 119, 0.04);

    .arrow {
      position: absolute;
      top: 50%;
      width: 0;
      height: 0;
      border-top: 6px solid transparent;
      border-bottom: 6px solid transparent;
      border-right: 7px solid var(--popover-label-surface);
      transform: translateY(-50%);
    }

    .arrow-left {
      left: -7px;
    }
  }

  .title {
    display: flex;
    align-items: center;
    min-height: 38px;
    margin: 0 8px 4px;
    color: var(--popover-text);
    font-size: 13px;
    font-weight: 800;
    letter-spacing: 0.01em;
  }

  .option {
    display: flex;
    align-items: center;
    padding: 0 10px 0 4px;
    font-size: 13px;
    height: 40px;
    min-height: 40px;
    border-radius: 8px;
    color: #a9bfd3;
    font-weight: 650;
    text-decoration: none;
    transition:
      color 140ms ease,
      background 140ms ease,
      transform 140ms ease;
    cursor: pointer;
    user-select: none;

    &:hover,
    &:focus-visible {
      color: var(--popover-text);
      background: rgba(89, 244, 119, 0.1);
      outline: none;
      transform: translateX(2px);
    }

    .icon {
      display: flex;
      justify-content: center;
      width: 36px;
      min-width: 36px;
      margin-right: 2px;
      color: #a9bfd3;

      svg {
        fill: currentcolor;
        width: 20px;
        min-width: 20px;
        height: auto;
      }

      svg [stroke] {
        stroke: currentColor;
      }
    }
  }

  .activated {
    color: var(--crypto-green, #59f477);
    filter: drop-shadow(0 0 6px rgba(89, 244, 119, 0.42));
  }

  .active-option {
    background: rgba(203, 215, 255, 0.03);
    color: var(--crypto-green);
    text-shadow: var(--crypto-green-glow) 0px 0px 8px;

    svg {
      filter: drop-shadow(var(--crypto-green-glow) 0px 0px 6px);
    }
  }
`;
